import {
	Modal,
	ModalBackdrop,
	ModalButtons,
	ModalCloseButton,
	ModalText,
	ModalTitle,
	PrimaryButton,
} from "components/Common";
import React, {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getErrorModalMessage} from "modules/selectors";
import {hideErrorModal} from "modules/actions";
import {useTranslation} from "react-i18next";
import {IconClose, IconError} from "components/Icons";

export const ErrorModal: React.FC = () => {
	const dispatch = useDispatch();
	const message = useSelector(getErrorModalMessage);
	const {t} = useTranslation();

	const closeModal = useCallback(() => {
		dispatch(hideErrorModal());
	}, [dispatch]);

	if (!message) {
		return null;
	}

	return (
		<ModalBackdrop>
			<Modal>
				<ModalCloseButton onClick={closeModal}>
					<IconClose />
				</ModalCloseButton>

				<IconError width={120} height={120} />

				<ModalTitle>{t("modal.error.title")}</ModalTitle>
				<ModalText>{message}</ModalText>

				<ModalButtons>
					<PrimaryButton onClick={closeModal}>{t("modal.error.close")}</PrimaryButton>
				</ModalButtons>
			</Modal>
		</ModalBackdrop>
	);
};
